import React from 'react';
import HeaderNormal from '../components/HeaderNormal';
import Footer from '../components/Footer';
import '../styles/Mentions.css';

const Mentions = () => {
  return (
    <>
      <HeaderNormal />
      <div className="mentions-container">
        <h1>📜 Mentions <span>Légales</span></h1>

        <section>
          <h2>Éditeur du site</h2>
          <p><strong>Meta Yachts Services</strong><br />
          Représentant légal : Frédéric Switala<br />
          Téléphone : +33 (0)6 03 53 65 93<br />
          Email : metayachtsservices@gmail.com<br />
          Adresse : IMP DE LA 1 ERE DFL PORT NAVYSERVICES, 13230 PORT-SAINT-LOUIS France<br />
          SIRET : 89821035600017<br />
          Statut juridique : Société par actions simplifiée</p>
        </section>

        <section>
          <h2>Hébergement</h2>
          <p>
            Render – <a href="https://render.com" target="_blank" rel="noopener noreferrer">https://render.com</a><br />
            340 S Lemon Ave #4133, Walnut, CA 91789, United States
          </p>
        </section>

        <section>
          <h2>Responsable de la publication</h2>
          <p>Frédéric Switala – metayachtsservices@gmail.com</p>
        </section>

        <section>
          <h2>Crédits</h2>
          <p>Design et développement : Edward Kaiser<br />
          Images, illustrations et contenus : droits réservés ou utilisés avec autorisation</p>
        </section>

        <section>
          <h2>Données personnelles</h2>
          <p>
            Le site ne collecte des données personnelles qu’à travers le formulaire de contact.
            Ces données sont utilisées uniquement pour répondre à votre demande.
            Conformément au RGPD, vous pouvez demander la suppression de vos données
            en écrivant à metayachtsservices@gmail.com
          </p>
        </section>

        <section>
          <h2>Cookies</h2>
          <p>
            Le site ne dépose pas de cookies de tracking. Aucune donnée de navigation
            n’est exploitée à des fins publicitaires.
          </p>
        </section>

        <section>
          <h2>Propriété intellectuelle</h2>
          <p>
            Tous les contenus (textes, images, logos, vidéos, modèles 3D, etc.) sont la propriété exclusive de META YACHTS SERVICES,
            sauf mention contraire. Toute reproduction, totale ou partielle, sans autorisation écrite est interdite.
          </p>
        </section>
      </div>

    </>
  );
};

export default Mentions;